import {LOCATE_SHOW_SIDER_DRAWER} from "../types";

const showSiderDrawer= (visible) => {
  return ({type: LOCATE_SHOW_SIDER_DRAWER, payload: {visibleSiderDrawer: visible}});
};

export default showSiderDrawer;